export default "/images/nomination3.jpg?9caf8096163f5f3564c970eab1673721";